(function() {
  'use strict';

  class ProductShowcase {
    constructor(el) {
      this.root = el;
      this.track = el.querySelector('.ps-track');
      this.cards = Array.from(el.querySelectorAll('.ps-card'));
      this.prevBtn = el.querySelector('.ps-nav--prev .ps-nav-btn');
      this.nextBtn = el.querySelector('.ps-nav--next .ps-nav-btn');

      this.autoPlay = el.dataset.autoplay === 'true';
      this.interval = parseInt(el.dataset.interval, 10) || 5000;
      this.pauseOnHover = el.dataset.pauseHover === 'true';

      this.total = this.cards.length;
      if (this.total < 1 || !this.track) return;

      this.current = this.total > 2 ? 1 : 0;
      this.timer = null;
      this.animating = false;
      this.resizeRaf = null;
      this.onResize = this.handleResize.bind(this);

      this.layout();
      this.updateInfoHeight();
      this.bind();
      if (this.autoPlay && this.total > 1) this.startAuto();
    }

    mod(n, m) {
      return ((n % m) + m) % m;
    }

    layout() {
      this.cards.forEach(card => {
        card.style.position = 'absolute';
        card.style.top = '0';
        card.style.left = '0';
        card.style.width = '100%';
        card.style.height = 'auto';
      });
      this.position();
    }

    position(animate) {
      const total = this.total;

      this.cards.forEach((card, i) => {
        const offset = this.getOffset(i);
        const abs = Math.abs(offset);

        card.style.transition = animate ? 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.5s ease, filter 0.5s ease' : 'none';

        if (abs > 2) {
          card.style.opacity = '0';
          card.style.pointerEvents = 'none';
          card.style.zIndex = '0';
          card.style.transform = `translateX(${offset > 0 ? 120 : -120}%) scale(0.8)`;
          return;
        }

        /* Side slides: very low opacity so outline doesn’t show behind center */
        const tx = offset * 60;
        const scale = abs === 0 ? 1 : 0.85;
        const z = abs === 0 ? 10 : (abs === 1 ? 5 : 1);
        const op = abs === 0 ? 1 : (abs === 1 ? 0.5 : 0);
        const sat = abs === 0 ? 1 : 0.3;
        const blur = abs === 0 ? '' : ' blur(1.5px)';

        card.style.transform = `translateX(${tx}%) scale(${scale})`;
        card.style.opacity = String(op);
        card.style.filter = `saturate(${sat})${blur}`.trim();
        card.style.zIndex = String(z);
        card.style.pointerEvents = abs <= 1 ? 'auto' : 'none';
      });
    }

    getOffset(index) {
      let diff = index - this.current;
      if (this.total > 2) {
        if (diff > this.total / 2) diff -= this.total;
        if (diff < -this.total / 2) diff += this.total;
      }
      return diff;
    }

    go(dir) {
      if (this.animating) return;
      this.animating = true;
      this.current = this.mod(this.current + dir, this.total);
      this.position(true);
      this.manageVideos();
      setTimeout(() => { this.animating = false; }, 520);
      this.resetAuto();
    }

    bind() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', (e) => { e.stopPropagation(); this.go(1); });

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', () => this.stopAuto());
        this.root.addEventListener('mouseleave', () => {
          if (this.autoPlay) this.startAuto();
        });
      }

      /* Click on a card to navigate: click next/prev visible image to go to it */
      this.track.addEventListener('click', (e) => {
        if (this.total <= 1) return;
        if (e.target.closest('a')) return;
        const card = e.target.closest('.ps-card');
        if (!card) return;
        const idx = this.cards.indexOf(card);
        if (idx === -1) return;
        const offset = this.getOffset(idx);
        if (offset === -1) this.go(-1);
        else if (offset === 1) this.go(1);
      });

      let touchX = 0;
      let touchY = 0;
      let swiping = false;

      this.track.addEventListener('touchstart', e => {
        touchX = e.touches[0].clientX;
        touchY = e.touches[0].clientY;
        swiping = true;
      }, { passive: true });

      this.track.addEventListener('touchmove', e => {
        if (!swiping) return;
        const dx = Math.abs(e.touches[0].clientX - touchX);
        const dy = Math.abs(e.touches[0].clientY - touchY);
        if (dy > dx) swiping = false;
      }, { passive: true });

      this.track.addEventListener('touchend', e => {
        if (!swiping) return;
        const diff = touchX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 40) {
          diff > 0 ? this.go(1) : this.go(-1);
        }
        swiping = false;
      }, { passive: true });

      window.addEventListener('resize', this.onResize, { passive: true });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.updateInfoHeight());
      }
    }

    isVisible() {
      const r = this.root.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    manageVideos() {
      this.cards.forEach((card, i) => {
        const video = card.querySelector('video');
        if (!video) return;
        if (i === this.current) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }

    startAuto() {
      this.stopAuto();
      if (this.total <= 1) return;
      this.timer = setInterval(() => this.go(1), this.interval);
    }

    stopAuto() {
      clearInterval(this.timer);
      this.timer = null;
    }

    resetAuto() {
      if (this.autoPlay) this.startAuto();
    }

    handleResize() {
      if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
      this.resizeRaf = requestAnimationFrame(() => {
        this.updateInfoHeight();
        this.resizeRaf = null;
      });
    }

    updateInfoHeight() {
      let maxInfoHeight = 0;
      this.cards.forEach(card => {
        const info = card.querySelector('.ps-card-info');
        if (!info) return;
        const h = Math.ceil(info.getBoundingClientRect().height);
        if (h > maxInfoHeight) maxInfoHeight = h;
      });

      if (maxInfoHeight > 0) {
        this.root.style.setProperty('--ps-info-height', `${maxInfoHeight}px`);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.product-showcase').forEach(el => {
      if (!el.dataset.initialized) {
        el.dataset.initialized = 'true';
        new ProductShowcase(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      const section = e.target.querySelector('.product-showcase');
      if (section) {
        section.removeAttribute('data-initialized');
        initAll();
      }
    });
  }
})();
